module.exports = __webpack_public_path__ + "static/media/icn_all_expenses_covid_fisdom.ef3ea5b6.svg";